// extracted by mini-css-extract-plugin
export default {"rich-text-editor":"mF1IU5pSv8qoTalPM1QIh"};